export default __webpack_public_path__ + "static/media/usa_flag.30d41210.svg";